import axios from "axios";
import { AccessTokenRequestBody, CenterPreferences } from "../user";
import { oauthConfig } from "../OauthConfig";
import { AuthAxios } from "./AuthAxios";
import { config } from "../config";

const baseUrl = `${oauthConfig.authority}/oauth`

export const UserApi = {
    async getAccessToken(token_endpoint: string, body: AccessTokenRequestBody) {
        const response = await axios.post(token_endpoint, body)
        return response
    },

    async refreshToken(refresh_token: string) {
        const response = await axios.post(`${baseUrl}/refresh_token`, {
            grant_type: "refresh_token",
            refresh_token: refresh_token,
            client_id: config.client_id
        })



        return response
    },

    async exchangeExternalToken(provider: string, token: string, center: number) {
        const response = await axios.post(`${baseUrl}/external/token`, {
            provider,
            token,
            center,
            client_id: config.client_id
        })
        return response
    },

    async getUserInfo() {
        const path = `${baseUrl}/userinfo`
        const response = await AuthAxios.get(path).catch((error) => error)
        return response
    },

    async saveUserCenterPreferences(preferences: CenterPreferences) {
        const path = `${oauthConfig.authority}/api/center/${preferences.center_id}/preferences`
        const response = await AuthAxios.post(path, {
            preferences: preferences
        }).catch((error) => error)
        return response
    },

    async deleteUserCenter(centerId: number) {
        const path = `${oauthConfig.authority}/api/center/${centerId}/delete`
        const response = await AuthAxios.post(path).catch((error) => error)
        return response
    }
}